var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-wepay-flow",class:{'weui-wepay-flow_vertical': _vm.orientation === 
'vertical'}},[_c('div',{staticClass:"weui-wepay-flow__bd"},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-465f3b6e","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flow/flow.vue
// module id = null
// module chunks = 